import { ClipboardList } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { GetReviewSummaryNodeData } from '@repo/shared-types';

export const GetReviewSummaryNode = ({
  data,
  selected,
}: {
  data: GetReviewSummaryNodeData;
  selected?: boolean;
}) => {
  const subtitle = [
    data.groupBy ? `by ${data.groupBy}` : null,
    data.outputKey ? `→ ${data.outputKey}` : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <NodeShell
      type="get_review_summary"
      icon={<ClipboardList size={16} />}
      label={data.label}
      subtitle={subtitle || undefined}
      selected={selected}
    />
  );
};
